function ageGroups_reducer(state = [], action) {
    switch (action.type) {
        case 'AGE_GROUPS/SET':
            return action.ageGroups;
        case 'AGE_GROUPS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default ageGroups_reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/ageGroups.js